import React, { useRef } from "react";
import { Typography, Box, Button, Grid, Divider, Chip, FormControlLabel, Checkbox } from "@mui/material";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import Signature from "../../../../common/signature/signature";

// Define validation schema
const validationSchema = Yup.object().shape({
  agree: Yup.boolean().oneOf([true, false], "You must accept the terms to proceed."),
});

const OfstedInspectContractAdmission = () => {
  const initialValues = {
    agree: false, // This must be initialized in Formik
  };

  const signatureRef = useRef(null);
  const signatureRefLeft = useRef(null);

  return (
    <Formik
      initialValues={initialValues}
      validationSchema={validationSchema}
      onSubmit={(values) => {
        const signatureData = signatureRef.current.getSignatureData();
        const signatureDataLeft = signatureRefLeft.current.getSignatureData();

        if (!signatureData || !signatureDataLeft) {
          alert("Please provide a signature");
          return;
        }

        const formData = { ...values, signatureLeft: signatureDataLeft, signature: signatureData }; // Include signature in form values

        console.log(formData);
      }}
    >
      {({ values, errors, touched, handleChange, handleBlur, handleSubmit }) => (
        <Form onSubmit={handleSubmit} className='ofsted-container'>
          <Box className='header-section-mobile'>
            <Chip label='Admission' />
            <Typography sx={{ fontSize: "22px", fontWeight: "bold", color: "black" }} align='left' mt={1}>
              Ofsted Inspection Contract
            </Typography>

            <Typography sx={{ fontSize: "14px" }} mt={1} mb={2}>
              Acknowledgment of Ofsted inspections, ensuring transparency and understanding of their purpose within the
              facility.
            </Typography>
          </Box>
          <Divider className='divider' />
          <Box className='content-section'>
            <Typography sx={{ fontSize: "14px" }} mt={2} color='info'>
              CYP Name
            </Typography>
            <Typography sx={{ fontSize: "14px", color: "black" }}>
              <FormControlLabel
                control={
                  <Checkbox
                    name='agree'
                    checked={values.agree}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    color='primary'
                  />
                }
                label=' I agree that I am aware who ofsted are and how they carry out inspections.'
                error={touched.agree && Boolean(errors.agree)}
              />
            </Typography>

            <Grid container ml={6} mt={3}>
              <Grid item xs={12} sm={4}>
                <Box className='signature-box'>
                  <Signature ref={signatureRefLeft} />
                  <Typography align='right'>
                    <Grid container>
                      <Grid>
                        <Typography sx={{ fontSize: "14px", color: "#FFB700" }}>Venorox </Typography>
                      </Grid>
                      <Grid>
                        <Grid>
                          <Typography sx={{ fontSize: "14px" }}>/ Signature</Typography>
                        </Grid>
                      </Grid>
                    </Grid>
                    <Grid className='clear-signature-button'>
                      <Button variant='outlined' onClick={() => signatureRefLeft.current?.clearSignature()}>
                        Clear
                      </Button>
                    </Grid>
                  </Typography>
                </Box>
              </Grid>
              <Grid item xs={12} sm={3}></Grid>
              <Grid item xs={12} sm={4}>
                <Box className='signature-box'>
                  <Signature ref={signatureRef} />
                  <Typography align='right'>
                    <Grid container>
                      <Grid>
                        <Typography sx={{ fontSize: "14px", color: "#FFB700" }}>Venorox </Typography>
                      </Grid>
                      <Grid>
                        <Grid>
                          <Typography sx={{ fontSize: "14px" }}>/ Signature</Typography>
                        </Grid>
                      </Grid>
                    </Grid>
                    <Grid className='clear-signature-button'>
                      <Button variant='outlined' onClick={() => signatureRef.current?.clearSignature()}>
                        Clear
                      </Button>
                    </Grid>
                  </Typography>
                </Box>
              </Grid>
            </Grid>
          </Box>
          <Grid item xs={12}>
            <div className='submit-button-container'>
              <Button type='submit' variant='contained' color='primary' className='submit-button'>
                Submit
              </Button>
            </div>
          </Grid>
        </Form>
      )}
    </Formik>
  );
};

export default OfstedInspectContractAdmission;
